import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';
import React, { useEffect, useRef, useState } from 'react';
import { setIsLoading } from '../general/actions';

import OrderSummary from './summary';

function Approve(props) {
    const { setIsLoading, is_provider } = props;

    const [orders, setOrders] = useState([]);

    const pollRef = useRef(null);
    const getOrdersRef = useRef(null);

    const getOrders = async (noShowLoading) => {
        if(!noShowLoading) {
            setIsLoading(true);
        }
        try {
            const response = await axiosInstance.get('/orders/pending');
            setOrders(response.data);
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    }


    // Keep ref pointing to the latest getOrders so the interval never captures a stale closure
    useEffect(() => { getOrdersRef.current = getOrders; });

    // Initialized
    useEffect(() => {
        getOrdersRef.current();

        clearInterval(pollRef.current);
        pollRef.current = setInterval(() => {
            getOrdersRef.current(true);
        }, 60000); // 60 s

        return () => {
            clearInterval(pollRef.current);
            pollRef.current = null;
        };
    }, []);

    return <>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, background: 'rgba(37,99,235,0.06)', border: '1px solid rgba(37,99,235,0.18)', borderRadius: 12, padding: '12px 16px', marginBottom: 14 }}>
            <div style={{ width: 36, height: 36, borderRadius: 10, background: 'var(--abi-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: 1 }}>
                <i className="fa fa-info" style={{ color: '#fff', fontSize: 15 }} />
            </div>
            <div style={{ fontSize: 13, color: 'var(--abi-text)', lineHeight: 1.65 }}>
                <strong>Flujo de aprobación de pedidos</strong>
                <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                    <span style={{ background: '#fef9c3', color: '#854d0e', border: '1px solid #fde047', borderRadius: 6, padding: '1px 8px', fontSize: 12, fontWeight: 600 }}>1: Creado</span>
                    <i className="fa fa-arrow-right" style={{ color: 'var(--abi-muted)', fontSize: 11 }} />
                    <span style={{ background: '#dbeafe', color: '#1e40af', border: '1px solid #93c5fd', borderRadius: 6, padding: '1px 8px', fontSize: 12, fontWeight: 600 }}>2: Aprobado</span>
                    <i className="fa fa-arrow-right" style={{ color: 'var(--abi-muted)', fontSize: 11 }} />
                    <span style={{ background: '#dcfce7', color: '#166534', border: '1px solid #86efac', borderRadius: 6, padding: '1px 8px', fontSize: 12, fontWeight: 600 }}>3: Aprobado - Proveedor</span>
                </div>
                <div style={{ marginTop: 6, color: 'var(--abi-muted)' }}>
                    Cada pedido requiere <strong>dos aprobaciones</strong>: la primera lo mueve de <em>Creado</em> a <em>Aprobado</em>, y la segunda de <em>Aprobado</em> a <em>Aprobado - Proveedor</em>.
                    Para aprobar, haz clic en{' '}
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, background: '#fff', border: '1px solid var(--abi-border)', borderRadius: 6, padding: '1px 7px', fontSize: 12, fontWeight: 600, verticalAlign: 'middle', color: 'var(--abi-text)' }}>
                        <i className="fa fa-check-circle" style={{ color: '#16a34a' }} /> Ver detalle
                    </span>{' '}
                    y usa el botón de aprobación dentro del detalle.
                </div>
            </div>
        </div>
        <OrderSummary getOrders={getOrders} orders={orders} isApproving={true}/>
    </>
}

function mapStateToProps(state) {
    return {
        isLoading: state.isLoading,
        is_provider: state.is_provider,
    };
}

const mapDispatchToProps = {
    setIsLoading
};

export default connect(mapStateToProps, mapDispatchToProps)(Approve);
